/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExpiresAt/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function ExpiresAt({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/AddAction/ApiToken/ExpiresAt",
  onChange
  
}) {
let appTokenExpiresAtValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'tokenExpiresAt',
})
let appTokenExpiresAtChangeData = fromData.useDataChange({ viewPath,
context: 'app',
path: 'tokenExpiresAt',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 type="date"
 label="Expires at"
 disablePast={true}
 yearPicker={true}
 data="app.tokenExpiresAt"
 onChange={appTokenExpiresAtChangeData}
 value={appTokenExpiresAtValueData}
/>
{children}
</React.Fragment>)
}